import React from "react";
import { Col } from "antd";

export function Messages() {
  return <Col style={{ marginTop: "20px" }}>Messages</Col>;
}
